
























































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import ProfileModule from '@/store/modules/Profile';
import Table from '@/components/Table/Index.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';

@Component({
  components: {
    Table,
  },
})
export default class ProfileView extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  userId = this.AuthInstance.user._id;

  ipWhitelist = this.AuthInstance.user.ipWhitelist[0];

  expJwt: any;

  currency = 'THB';

  TableHead = [
    [
      {
        displayName: 'profile.date',
      },
      {
        displayName: 'profile.ip',
      },
    ],
  ];

  dataModel = {
    profile: {
      ...this.AuthInstance.user.profile,
    },
  }

  async created() {
    const expToken: any = jwt_decode(this.AuthInstance.token);
    this.currency = expToken.currency;
  }

  async onSubmitInfo() {
    const { dataModel: { profile }, userId, ipWhitelist } = this;
    const res = await this.ProfileInstance.UpdateProfile({
      userId,
      profile,
      ipWhitelist,
    });
    this.checkError(res);
    this.ProfileInstance.FetchProfile();
  }
}
